import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpMoReportPrintPage } from '@/features/pcmp/pages/PcmpMoReportPrintPage';
import { pcmpMoReportSearchSchema } from '@/features/pcmp/types/pcmpMoReport.types';

export const Route = createFileRoute('/_print/pcmp/reports/mo-wise/print')({
  validateSearch: pcmpMoReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP MO Wise Report">
      <PcmpMoReportPrintPage />
    </ErrorBoundary>
  ),
});
